<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
  <p
    :class="cn('flex items-center justify-center gap-2 py-3 text-sm font-medium text-brand-primary-700', $props.class)"
  >
    <UiCustomRangeCalendarDirectFlightDot />
    {{ $t('components.search.datepicker.directFlightLegend') }}
  </p>
</template>
